import React, { Component } from "react";

import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import OrderedSupplierList from "./OrderedSupplierList.js";
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import NativeSelect from '@material-ui/core/NativeSelect';

class CustomerProductRow extends Component {
	constructor(props) {
		super(props);
		this.handleMorePriority=this.handleMorePriority.bind(this);
		this.handleChangeConfig=this.handleChangeConfig.bind(this);
	}
	
	handleMorePriority(index, idSupplierConfig){
		this.props.morePriority(this.props.id, index, idSupplierConfig);
	}
	
	handleChangeConfig(e){
		e.preventDefault();
		const {name, value} = e.target;
//		console.log("["+name+","+value+"]");
		this.props.changConfig(this.props.id, value);
	}
	
	render() {
//		console.log("CustomerProductRow RENDER");
//		console.log(this.props);
		var translationConfSelect="";
		if(this.props.description=="Translation"){
			const configList = [];
			configList.push(<option value=''></option>);
			configList.push(<option value='TA_Apertium'>TA_Apertium</option>);
			configList.push(<option value='TA_DeepL'>TA_DeepL</option>);
			configList.push(<option value='TA_Google'>TA_GoogleT</option>);
			translationConfSelect = <Grid item><NativeSelect
									value={this.props.wfConfig}
									onChange={this.handleChangeConfig}
									>
									{configList}
								</NativeSelect></Grid>
		}
		let tmx ="";
		if(this.props.tmx){
			let links = this.props.tmx.links.find(function(l){return l.rel=="self";});
			let tmxLink = <a target="_blank" style={{textDecoration: 'none', textAlign: 'right'}} href={links.href+"/?access_token="+this.props.accessToken} title={this.props.tmx.description}>{this.props.tmx.description}</a>;
			let changeLink = <Link style={{textDecoration: 'none'}} to={`/tmxSelectionForm/${this.props.customer}/${this.props.tmx.languagePair.id}/${this.props.tmx.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59392;</Icon></Link>
			tmx = <Grid container direction="row" alignItems="center" justify="flex-start" spacing={1}><Grid style={{textAlign: 'right'}} item xs={10}>{tmxLink}</Grid><Grid item xs={2}>{changeLink}</Grid></Grid>
		}else{
			let changeLink = <Link style={{textDecoration: 'none'}} to={`/tmxSelectionForm/${this.props.customer}/${this.props.langPairId}/0`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59392;</Icon></Link>
			tmx = <Grid container direction="row" alignItems="center" justify="flex-start" spacing={0}><Grid item xs={10}> </Grid><Grid item xs={2}>{changeLink}</Grid></Grid>
		}
		let glossary="";
		let glosaryFormLink="";
		if(this.props.glossary){
			let glossaryLink = <a target="_blank" style={{textDecoration: 'none'}} href={process.env.REACT_APP_serverURL+"/documents-0.0.1/glossary/"+this.props.glossary.id+"/content?access_token="+this.props.accessToken} title={this.props.glossary.description}>{this.props.glossary.description}</a>;
			glosaryFormLink = <Link style={{textDecoration: 'none'}} to={`/glossaryForm/${this.props.customer}/${this.props.langPairId}/${this.props.glossary.id}`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59392;</Icon></Link>
			glossary=<Grid container direction="row" alignItems="center" justify="flex-start" spacing={0}><Grid item xs={10}>{glossaryLink}</Grid><Grid item xs={2}>{glosaryFormLink}</Grid></Grid>;
		}else{
			glosaryFormLink = <Link style={{textDecoration: 'none'}} to={`/glossaryForm/${this.props.customer}/${this.props.langPairId}/0`}><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#000", cursor: "pointer"}}>&#59392;</Icon></Link>
			glossary=<Grid container direction="row" alignItems="center" justify="flex-start" spacing={0}><Grid item xs={10}> </Grid><Grid item xs={2}>{glosaryFormLink}</Grid></Grid>;
		}
		return (
			<TableRow key={this.props.id}>
			<TableCell>{this.props.description}</TableCell>
			<TableCell>{translationConfSelect}</TableCell>
			<TableCell>{this.props.langPairCode}</TableCell>
			<TableCell><OrderedSupplierList suppliers={this.props.suppliers}
											morePriority={this.handleMorePriority}
											users={this.props.users}
											supplierConfig={this.props.supplierConfig}/>
			</TableCell>
			<TableCell>{glossary}</TableCell>
			<TableCell>{tmx}</TableCell>
			</TableRow>
		);
	}
}

export default CustomerProductRow;